
<template>

    <div>
        <SingleTextOnlineProfileMetric v-for="profileMetric in profileMetrics" :key="profileMetric.id" :is-single-profile="false" :profileMetric="profileMetric"/>
    </div>

</template>

<script>
import SingleTextOnlineProfileMetric
    from "@/dashboards/widgets/onlineprofile/textonlineprofile/SingleTextOnlineProfileMetric.vue";

export default {
    name: "MultiTextOnlineProfileMetric",
    components: {SingleTextOnlineProfileMetric},

    props: {
        profileMetrics: {
            type: [],
            required: true
        },
        isSingleProfile: {
            type: Boolean,
            required: true
        }
    },
}
</script>

<style scoped lang="sass">

</style>